// src/pages/website/PricingPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';
import './website.css';

const BULK_TIERS = [
  { qty: '1–10',    digital: '₹10',  physical: '₹399', save: '' },
  { qty: '11–50',   digital: '₹8',   physical: '₹349', save: '20% off' },
  { qty: '51–200',  digital: '₹6',   physical: '₹299', save: '40% off' },
  { qty: '201–500', digital: '₹4',   physical: '₹249', save: '60% off' },
  { qty: '500+',    digital: 'Custom', physical: 'Custom', save: 'Contact us' },
];

export default function PricingPage() {
  return (
    <div className="website-page">
      <Navbar />

      <section style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0066cc 100%)',
        color: '#fff', padding: '60px 5%', textAlign: 'center'
      }}>
        <h1 style={{ fontSize: 40, fontWeight: 800, marginBottom: 12 }}>Simple Pricing</h1>
        <p style={{ fontSize: 17, opacity: 0.85 }}>No subscriptions. Pay once per QR code.</p>
      </section>

      <section className="section">
        <div className="section-header">
          <div className="section-label">Individual Plans</div>
          <h2>For Families & Individuals</h2>
        </div>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Digital QR</h3>
            <p style={{ color: '#666', fontSize: 14 }}>Download and print yourself</p>
            <div className="price">₹10 <span>/ QR</span></div>
            <div className="price-note">One-time, no subscription</div>
            <ul className="pricing-features">
              <li>High resolution PNG</li>
              <li>Phone back cover card format</li>
              <li>Keychain / bag tag format</li>
              <li>Instant download</li>
              <li>Valid forever</li>
            </ul>
            <a href="https://play.google.com/store/apps/details?id=com.civicsetu.app"
              className="web-btn web-btn-outline" style={{ width: '100%', justifyContent: 'center' }}>
              Download App
            </a>
          </div>

          <div className="pricing-card featured">
            <div className="pricing-badge">Most Popular</div>
            <h3>Physical QR</h3>
            <p style={{ color: '#666', fontSize: 14 }}>Printed & couriered to you</p>
            <div className="price">₹399 <span>/ QR</span></div>
            <div className="price-note">Free shipping across India</div>
            <ul className="pricing-features">
              <li>Professional print quality</li>
              <li>Paper laminated — ₹399</li>
              <li>Vinyl sticker — ₹449 (weatherproof)</li>
              <li>Delivered in 3–5 business days</li>
              <li>Valid forever</li>
            </ul>
            <a href="https://play.google.com/store/apps/details?id=com.civicsetu.app"
              className="web-btn web-btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
              Order Now
            </a>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="section-header">
          <div className="section-label">Bulk Plans</div>
          <h2>For Schools & Institutions</h2>
          <p>Volume discounts up to 60%. GST invoice included.</p>
        </div>

        <div style={{ overflowX: 'auto', maxWidth: 800, margin: '0 auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Quantity</th>
                <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600 }}>Digital QR</th>
                <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600 }}>Physical QR</th>
                <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600 }}>Savings</th>
              </tr>
            </thead>
            <tbody>
              {BULK_TIERS.map((t, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 16px', fontWeight: 500 }}>{t.qty}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center', color: '#0066cc', fontWeight: 600 }}>{t.digital}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center', color: '#0066cc', fontWeight: 600 }}>{t.physical}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                    {t.save && (
                      <span style={{
                        background: '#e6f4ea', color: '#137333',
                        padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600
                      }}>{t.save}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: 'center', marginTop: 28 }}>
          <Link to="/bulk/login" className="web-btn web-btn-accent web-btn-lg">
            🏫 Start Bulk Order
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
